module.exports = __webpack_public_path__ + "static/media/angle-up.4654f23e.svg";